module.exports = __webpack_public_path__ + "img/remove_account_2.0b9cd0a0.png";